import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { HelpersService } from './helpers.service';
import { InterstitialModalComponent } from '../components/modal-placeholder/interstitial-modal/interstitial-modal.component';
import { InterstitialLongComponent } from '../components/modal-placeholder/interstitial-long/interstitial-long.component';
import { InterstitialModalSpComponent } from '../components/modal-placeholder/interstitial-modal-sp/interstitial-modal-sp.component';
import { InterstitialLongSpComponent } from '../components/modal-placeholder/interstitial-long-sp/interstitial-long-sp.component';
import { VideoAdamComponent } from '../components/modal-placeholder/video-adam/video-adam.component';
import { VideoAmandaComponent } from '../components/modal-placeholder/video-amanda/video-amanda.component';
import { SmsTermsModalComponent } from '../components/modal-placeholder/sms-terms-modal/sms-terms-modal.component';
import { InterstitialHcp } from '../components/modal-placeholder/interstitial-hcp/interstitial-hcp';

type ModalOptions =
  | 'interstitial'
  | 'interstitialLong'
  | 'interstitialSp'
  | 'interstitialLongSp'
  | 'videoAdam'
  | 'videoAmanda'
  | 'smsTerms'
  | 'interstitialHCP';

@Injectable({
  providedIn: 'root',
})
export class GlobalModalService {
  private modals = {
    interstitial: InterstitialModalComponent,
    interstitialLong: InterstitialLongComponent,
    interstitialSp: InterstitialModalSpComponent,
    interstitialLongSp: InterstitialLongSpComponent,
    videoAdam: VideoAdamComponent,
    videoAmanda: VideoAmandaComponent,
    smsTerms: SmsTermsModalComponent,
    interstitialHCP: InterstitialHcp,
  };

  private modalOptions: NgbModalOptions = {
    centered: true,
    backdrop: 'static',
    keyboard: true,
  };

  //classes to apply while modal is open
  private noScrollableSection = 'overflow-hidden';
  private viewportH = 'vh-100';

  constructor(
    private modalService: NgbModal,
    private helpersService: HelpersService,
  ) {}

  private getModal(modal: ModalOptions) {
    return this.modals[modal];
  }

  openModal(
    modal: ModalOptions,
    interstitialURL?: string,
    options?: NgbModalOptions,
  ) {
    if (!this.helpersService.validatePlatform()) return;

    const modalRef = this.modalService.open(
      this.getModal(modal),
      options || this.modalOptions,
    );

    interstitialURL && (modalRef.componentInstance.url = interstitialURL);
    document.documentElement.classList.add(this.noScrollableSection);
    document.body.classList.add(this.noScrollableSection, this.viewportH);
    // Will apply vh-100 because of a known issue in iOS where using only overflow-hidden is ignored by Safari
  }

  setScrollingInPage() {
    if (!this.helpersService.validatePlatform()) return;
    document.documentElement.classList.remove(this.noScrollableSection);
    document.body.classList.remove(this.noScrollableSection, this.viewportH);
  }

  closeAllModals() {
    this.modalService.dismissAll();
    this.setScrollingInPage();
  }
}
